import { LereToursPricingHistoryParams } from '~/components/LERE/types';

export const lereToursPricingHistoryQueryKeys = {
  all: ['lere', 'tours-pricing-history'] as const,
  lists: () => [...lereToursPricingHistoryQueryKeys.all, 'list'] as const,
  list: (params: LereToursPricingHistoryParams) => [...lereToursPricingHistoryQueryKeys.lists(), params] as const,
};
